// extracted by mini-css-extract-plugin
module.exports = {"quantity":"wD0Bu","add-to-cart":"-9iUh","button":"VjDIU"};